import { FC, useEffect } from 'react';
import * as React from 'react';

import { useAccountData } from './useAccountData';
import {
  StyleApplicationWrapper,
  StyledApplicationLayout,
  StyledPrimaryMenuAnalyticsWrapper,
  StyledSideMenuAnalyticsWrapper,
} from './ApplicationWrapper.styled';
import { ApplicationWrapperProps } from './ApplicationWrapper.types';
import { AccountContextProvider } from './context/account/Account.context';
import { useCustomerIdContext } from './context';
import { UnicornApiContext } from './UnicornApi.context';

const onResize = () => {
  document.documentElement.style.setProperty('--inner-height', `${window.innerHeight}px`);
};

export const ApplicationWrapperCommon: FC<ApplicationWrapperProps> = ({ isMobile, primaryMenu, sideBarMenu, children }) => {
  useEffect(() => {
    // since in CSS the logic relies on support for -webkit-touch-callout
    if (isMobile || window.CSS.supports('(-webkit-touch-callout: none)')) {
      onResize();

      window.addEventListener('resize', onResize);

      return () => {
        window.removeEventListener('resize', onResize);
      };
    }
  }, [isMobile]);

  return (
    <>
      <StyledPrimaryMenuAnalyticsWrapper category="primary menu">{primaryMenu}</StyledPrimaryMenuAnalyticsWrapper>
      <StyledSideMenuAnalyticsWrapper category="side menu">{sideBarMenu}</StyledSideMenuAnalyticsWrapper>
      <StyleApplicationWrapper>{children}</StyleApplicationWrapper>
    </>
  );
};

export const ApplicationWrapper: FC<ApplicationWrapperProps> = (props) => {
  return <ApplicationWrapperResponsive {...props} isMobile={false} />;
};

export const ApplicationWrapperResponsive: FC<ApplicationWrapperProps> = ({
  header,
  primaryMenu,
  sideBarMenu,
  children,
  isMobile,
  unicornApi,
  ...rest
}) => {
  const { currentCustomer } = useCustomerIdContext();
  const accountData = useAccountData({ customerExternalId: currentCustomer?.externalId, unicornApi });

  const content = (
    <AccountContextProvider value={accountData}>
      <StyledApplicationLayout isMobile={isMobile} {...rest}>
        <ApplicationWrapperCommon isMobile={isMobile} primaryMenu={primaryMenu} sideBarMenu={sideBarMenu} children={children} />
      </StyledApplicationLayout>
    </AccountContextProvider>
  );

  return (
    <UnicornApiContext.Provider value={{ unicornApi }}>
      {header}
      {content}
    </UnicornApiContext.Provider>
  );
};
